import { EventBus } from '../../helpers';

type PrepaySelectEvents = {
  prepayChanged: [periodId: string];
};

class PrepaySelectEventBus extends EventBus<PrepaySelectEvents> {}

export const prepaySelectEventBus = new PrepaySelectEventBus();
